(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[901],{

/***/ 68730:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deals",
      function () {
        return __webpack_require__(88741);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ usePageEntrance; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74682);
/* harmony import */ var _app_config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31470);
/* harmony import */ var _app_config_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_config_js__WEBPACK_IMPORTED_MODULE_1__);
/* eslint-disable */ 


var usePageEntrance = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), once = ref[0], setOnce = ref[1];
    var onceVar = false;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (once || onceVar) {
            return;
        }
        setOnce(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        onceVar = true;
        // @ts-ignore
        var timeline = new gsap__WEBPACK_IMPORTED_MODULE_2__/* .gsap.timeline */ .p8.timeline();
        var int = setInterval(function() {
            if ((_app_config_js__WEBPACK_IMPORTED_MODULE_1___default().transitionFinished)) {
                clearInterval(int);
                var enterEls = document.querySelectorAll(".enter-el, .enter-el-block, .enter-el-inherit");
                timeline.fromTo(enterEls, {
                    y: 40
                }, {
                    y: 0,
                    stagger: .07,
                    force3D: true,
                    duration: 1.4,
                    ease: "expo.out"
                }).fromTo(enterEls, {
                    opacity: 0
                }, {
                    opacity: 1,
                    stagger: .07,
                    force3D: true,
                    duration: 1.35,
                    ease: "expo.out"
                }, 0.05);
            }
        });
    });
};


/***/ }),

/***/ 88741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ deals; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/moment-timezone/builds/moment-timezone-with-data-2012-2022.js
var moment_timezone_with_data_2012_2022 = __webpack_require__(33353);
var moment_timezone_with_data_2012_2022_default = /*#__PURE__*/__webpack_require__.n(moment_timezone_with_data_2012_2022);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/Table/DealTable.tsx + 3 modules
var DealTable = __webpack_require__(22115);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/use-combobox/use-combobox.mjs + 1 modules
var use_combobox = __webpack_require__(43630);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/Combobox.mjs + 38 modules
var Combobox = __webpack_require__(96644);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/components/Group/Group.mjs + 2 modules
var Group = __webpack_require__(82696);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/components/Checkbox/CheckIcon.mjs
var CheckIcon = __webpack_require__(92297);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/components/Button/Button.mjs + 7 modules
var Button = __webpack_require__(5546);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/react-icons/io/index.esm.js
var index_esm = __webpack_require__(85819);
// EXTERNAL MODULE: ./utilities/__generated__/graphql.ts + 21 modules
var graphql = __webpack_require__(30207);
// EXTERNAL MODULE: ./utilities/createBucketUrl.ts
var createBucketUrl = __webpack_require__(37785);
;// CONCATENATED MODULE: ./components/UI/filters/CollectionsFilter.tsx








function CollectionsFilter(param) {
    var onSelected = param.onSelected;
    var ref = (0,react.useState)([]), selectedItems = ref[0], setSelectedItems = ref[1];
    var data = (0,graphql/* useGetCollectionsQuery */.dW)().data;
    var combobox = (0,use_combobox/* useCombobox */.K)({
        onDropdownClose: function() {
            return combobox.resetSelectedOption();
        }
    });
    var ref1;
    var options = ((ref1 = data === null || data === void 0 ? void 0 : data.Collections) !== null && ref1 !== void 0 ? ref1 : []).map(function(item) {
        var selected = selectedItems.includes(item.nft_contract_address);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Combobox/* Combobox.Option */.h.Option, {
            value: item.nft_contract_address,
            px: 8,
            py: 2,
            className: "".concat(selected ? "bg-primary-surface text-black" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                className: "justify-between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative flex items-center justify-center",
                            children: [
                                selected && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon/* CheckIcon */.n, {
                                    size: 12,
                                    className: "absolute z-10 m-auto text-primary-main"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    alt: "".concat(item.name, " logo"),
                                    className: "rounded-md ".concat(selected ? "opacity-20" : "opacity-100"),
                                    src: (0,createBucketUrl/* createBucketURL */.C)(createBucketUrl/* BucketType.Collection */.a.Collection, item.nft_contract_address),
                                    height: 35,
                                    width: 35
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: item.name
                        })
                    ]
                })
            })
        }, item.nft_contract_address);
    });
    var itemsSelected = selectedItems.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Combobox/* Combobox */.h, {
            store: combobox,
            width: "auto",
            zIndex: 2,
            keepMounted: true,
            withinPortal: true,
            positionDependencies: [
                selectedItems
            ],
            onOptionSubmit: function(val) {
                setSelectedItems(function(current) {
                    var newItems = current.includes(val) ? current.filter(function(item) {
                        return item !== val;
                    }) : (0,_to_consumable_array/* default */.Z)(current).concat([
                        val
                    ]);
                    onSelected(newItems);
                    return newItems;
                });
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Combobox/* Combobox.Target */.h.Target, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        p: 0,
                        m: 4,
                        onClick: function() {
                            return combobox.toggleDropdown();
                        },
                        className: "flex h-full items-center justify-center bg-transparent hover:bg-transparent",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-[176px] items-center justify-center space-x-3 rounded-lg border-[2px] px-6 py-3 text-md font-medium ".concat(combobox.dropdownOpened ? "border-primary-surface bg-primary-main text-white" : "".concat(itemsSelected ? "border-primary-surface bg-primary-surface text-primary-main" : "border-neutral-20 bg-white text-black", " hover:border-primary-surface hover:bg-primary-surface")),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: !itemsSelected ? "Collections" : "".concat(selectedItems.length, " Collection").concat(selectedItems.length > 1 ? "s" : "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: combobox.dropdownOpened ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosArrowUp */.Vmf, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosArrowDown */.OId, {})
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Combobox/* Combobox.Dropdown */.h.Dropdown, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Combobox/* Combobox.Options */.h.Options, {
                        className: "text-black",
                        children: options
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var filters_CollectionsFilter = ((/* unused pure expression or super */ null && (CollectionsFilter)));

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/UI/Pill.tsx
var Pill = __webpack_require__(50850);
// EXTERNAL MODULE: ./components/UI/buttons/Button.tsx + 3 modules
var buttons_Button = __webpack_require__(21489);
;// CONCATENATED MODULE: ./components/cards/HighlightCTA.tsx




var HighlightCTA = function(param) {
    var headline = param.headline, coverImageUrl = param.coverImageUrl, ctaLink = param.ctaLink, lowerText = param.lowerText, pillText = param.pillText, _pillPulse = param.pillPulse, pillPulse = _pillPulse === void 0 ? false : _pillPulse, _pillTheme = param.pillTheme, pillTheme = _pillTheme === void 0 ? Pill/* PillTheme.NEUTRAL */.W$.NEUTRAL : _pillTheme;
    var primary = Pill/* pillThemeColors */.ie[pillTheme].primary;
    var borderColor = pillTheme === Pill/* PillTheme.GREEN */.W$.GREEN ? "white" : primary;
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-gridOverlay aspect-w-16 aspect-h-9 relative flex h-[400px] w-full flex-col items-center justify-center overflow-hidden rounded-3xl p-14 md:max-h-full md:items-start md:justify-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 z-0 rounded-3xl bg-right-top bg-no-repeat",
                style: {
                    backgroundImage: "url(".concat(coverImageUrl, ")")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute inset-0 bg-black opacity-40 lg:hidden"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative z-10 flex w-full flex-col items-center md:max-w-[450px] md:items-start",
                children: [
                    pillText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* default */.ZP, {
                        theme: pillTheme,
                        showDot: true,
                        pulse: pillPulse,
                        classes: "mt-0 rounded-lg border-[1.5px] text-white text-sm border-accent-focus border-".concat(borderColor, " bg-accent-hover bg-gradient-to-b from-accent-main to-accent-pressed"),
                        children: pillText
                    }),
                    headline && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "z-10 mt-2 break-words bg-gradient-to-r from-uniqueFade-light to-white bg-clip-text pb-7 text-center font-gt-haptik font-bold leading-none text-transparent ".concat(headline.length > 40 ? "text-heading-4 md:text-heading-3" : "text-heading-3 md:text-heading-2", " md:text-left"),
                        children: headline
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons_Button/* default */.ZP, {
                        type: buttons_Button/* ButtonType.primary */.L$.primary,
                        size: buttons_Button/* ButtonSize.xs */.qE.xs,
                        children: lowerText
                    })
                ]
            })
        ]
    });
    return ctaLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: ctaLink,
        passHref: true,
        className: "flex h-full w-full items-center justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            children: content
        })
    }) : content;
};

// EXTERNAL MODULE: ./components/head/SeoHead.tsx
var SeoHead = __webpack_require__(637);
// EXTERNAL MODULE: ./components/layout/PageContainer.tsx
var PageContainer = __webpack_require__(37742);
// EXTERNAL MODULE: ./constants/constants.ts
var constants = __webpack_require__(36630);
// EXTERNAL MODULE: ./hooks/usePageEntrance.ts
var usePageEntrance = __webpack_require__(7414);
;// CONCATENATED MODULE: ./models/Filters.ts
var FilterTypes;
(function(FilterTypes) {
    FilterTypes[FilterTypes["Collection"] = 0] = "Collection";
})(FilterTypes || (FilterTypes = {}));

// EXTERNAL MODULE: ./utilities/dateFormatter.ts
var dateFormatter = __webpack_require__(17695);
// EXTERNAL MODULE: ./utilities/createApolloClient.ts + 68 modules
var createApolloClient = __webpack_require__(39876);
// EXTERNAL MODULE: ./utilities/functions.ts + 5 modules
var functions = __webpack_require__(12477);
;// CONCATENATED MODULE: ./utilities/deals/loadDeals.ts







//TODO: this needs better error handling
function loadDeals(_) {
    return _loadDeals.apply(this, arguments);
}
function _loadDeals() {
    _loadDeals = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var limit, dealCondition, client, filterTypes, _type, dealConditions, data, sortedDeals;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    limit = param.limit, dealCondition = param.dealCondition;
                    client = (0,createApolloClient/* createApolloClient */.nl)();
                    filterTypes = [
                        FilterTypes.Collection
                    ];
                    ;
                    dealConditions = {
                        _and: (0,_to_consumable_array/* default */.Z)(filterTypes.map(function(type) {
                            return (_type = (dealCondition !== null && dealCondition !== void 0 ? dealCondition : {})[type]) !== null && _type !== void 0 ? _type : {};
                        }))
                    };
                    _ctx.next = 7;
                    return client.query({
                        query: graphql/* GetDealsDocument */.Qv,
                        variables: {
                            limit: limit,
                            dealsWhere: dealConditions
                        }
                    });
                case 7:
                    data = _ctx.sent.data;
                    sortedDeals = (0,functions/* sortDeals */.Dy)(data.Deals);
                    return _ctx.abrupt("return", {
                        deals: sortedDeals
                    });
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _loadDeals.apply(this, arguments);
}

;// CONCATENATED MODULE: ./pages/deals.tsx



















var DealsPage = function() {
    var ref = (0,react.useState)([]), allDeals = ref[0], setAllDeals = ref[1];
    var ref1 = (0,react.useState)([]), deals = ref1[0], setDeals = ref1[1];
    var ref2 = (0,react.useState)(null), randomFeaturedOpportunity = ref2[0], setRandomFeaturedOpportunity = ref2[1];
    var ref3 = (0,react.useState)(true), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)({}), filterConditions = ref4[0], setFilterConditions = ref4[1];
    (0,usePageEntrance/* usePageEntrance */.s)();
    (0,react.useEffect)(function() {
        var loadAllDeals = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var deals;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return loadDeals({
                                date: moment_timezone_with_data_2012_2022_default()().tz(moment_timezone_with_data_2012_2022_default().tz.guess()).format()
                            });
                        case 2:
                            deals = _ctx.sent.deals;
                            setAllDeals(deals);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function loadAllDeals() {
                return _ref.apply(this, arguments);
            };
        }();
        loadAllDeals();
    }, []);
    (0,react.useEffect)(function() {
        var loadFilteredDeals = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var currentTime, deals;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            currentTime = moment_timezone_with_data_2012_2022_default()().tz(moment_timezone_with_data_2012_2022_default().tz.guess()).format();
                            _ctx.next = 3;
                            return loadDeals({
                                date: currentTime,
                                dealCondition: filterConditions
                            });
                        case 3:
                            deals = _ctx.sent.deals;
                            return _ctx.abrupt("return", deals);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function loadFilteredDeals() {
                return _ref.apply(this, arguments);
            };
        }();
        loadFilteredDeals().then(function(res) {
            setDeals(res);
            setLoading(false);
        });
    }, [
        filterConditions
    ]);
    var selectCollectionHandler = function(collections) {
        var collectionCondition = !collections.length ? {} : {
            CollectionDeals: {
                Collection: {
                    nft_contract_address: {
                        _in: collections
                    }
                }
            }
        };
        setFilterConditions(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, FilterTypes.Collection, collectionCondition));
        });
    };
    (0,react.useEffect)(function() {
        var featuredDeals = allDeals.filter(function(deal) {
            return deal.is_featured && deal.bidding_expiration && moment_timezone_with_data_2012_2022_default()(deal.bidding_expiration).isAfter(moment_timezone_with_data_2012_2022_default()());
        });
        if (featuredDeals.length > 0) {
            var randomIndex = Math.floor(Math.random() * featuredDeals.length);
            setRandomFeaturedOpportunity(featuredDeals[randomIndex]);
        } else {
            setRandomFeaturedOpportunity(null);
        }
    }, [
        allDeals
    ]);
    var localBiddingExpDate;
    var humanizedLocalBiddingExpDate;
    var dateEnum;
    var theme;
    var pulse;
    if (randomFeaturedOpportunity) {
        var ref5, ref6;
        localBiddingExpDate = (0,dateFormatter/* getLocalDate */.ZF)(randomFeaturedOpportunity.bidding_expiration, constants/* DATE_FORMATS.MMMDYhm */.lv.MMMDYhm);
        var ref7;
        ref7 = (0,_sliced_to_array/* default */.Z)((0,dateFormatter/* getHumanizedDate */.n$)(localBiddingExpDate), 2), humanizedLocalBiddingExpDate = ref7[0], dateEnum = ref7[1], ref7;
        theme = (ref5 = dateFormatter/* DateThemeMap */.xj[dateEnum]) === null || ref5 === void 0 ? void 0 : ref5.theme;
        pulse = (ref6 = dateFormatter/* DateThemeMap */.xj[dateEnum]) === null || ref6 === void 0 ? void 0 : ref6.pulse;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoHead/* default */.Z, {
                title: "OverpassIP | All Licensing Opportunities",
                imageURI: "/img/OverPassCover.png",
                description: "Most people don’t have the resources, time, or connections to truly use\n        their web3 IP. Our goal at OverpassIP is to provide holders with easily\n        accessible opportunities to leverage their NFT’s IP. With OverpassIP,\n        the Web3 user will seamlessly connect with the Web2 brand. Join us in\n        revolutionizing IP functionality for years to come."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageContainer/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "enter-el-inherit py-0 font-gt-haptik text-heading-5-mobile font-bold text-black md:px-4 md:text-heading-5",
                        children: "Licensing Opportunities"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "enter-el-inherit pt-2 text-left text-lg text-neutral-50 md:px-4 md:text-lg ",
                        children: "Explore OverpassIP licensing opportunities."
                    }),
                    randomFeaturedOpportunity && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "emter-el mt-4 md:mx-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightCTA, {
                            headline: randomFeaturedOpportunity.title,
                            pillPulse: pulse,
                            pillTheme: theme,
                            pillText: "Submit by ".concat(humanizedLocalBiddingExpDate),
                            coverImageUrl: "".concat(constants/* BUCKET_URL */.Q3, "opportunity/").concat(randomFeaturedOpportunity.id),
                            lowerText: "View Opportunity",
                            ctaLink: "/deal/".concat(randomFeaturedOpportunity.id)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "enter-el-inherit awaiting-content w-full pt-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DealTable/* default */.Z, {
                                emptyCardText: "No Opportunities",
                                deals: deals,
                                filters: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex space-x-3 overflow-scroll md:pr-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionsFilter, {
                                        onSelected: selectCollectionHandler
                                    })
                                }),
                                isLoading: loading
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var deals = (DealsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [246,947,3661,5984,5816,5505,844,6570,4140,9774,2888,179], function() { return __webpack_exec__(68730); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);